import clsx from "clsx"
import { useState } from "react"

interface QuestionProps {
  question: string
  answer: string
}

export default function Question(props: QuestionProps) {
  const { question, answer } = props
  const [open, setOpen] = useState<boolean>(false)

  return (
    <div
      className={clsx(
        "flex w-full shrink-0 flex-col overflow-hidden rounded-[10px] bg-color-cell",
        "tablet:w-[572px] desktop:w-[729px]",
      )}>
      <div
        onClick={() => setOpen(!open)}
        className={clsx(
          "flex cursor-pointer select-none flex-row items-center justify-between p-4",
          open && "border-b border-color-separator",
        )}>
        <p
          className={clsx(
            "text-body-3 transition-colors duration-300",
            open && "text-primary-500",
          )}>
          {question}
        </p>

        <div className="button relative max-h-[16px] min-h-[16px] min-w-[16px] max-w-[16px] cursor-pointer">
          <span
            className={clsx(
              open && "rotate-90",
              "before-line absolute bg-blue-400 transition-transform duration-[250ms] ease-out",
            )}></span>
          <span
            className={clsx(
              open ? "bg-primary-500" : "bg-blue-400",
              "after-line absolute transition-transform duration-[250ms] ease-out",
            )}></span>
        </div>
      </div>
      <p
        className={clsx(
          open
            ? "text-body-5 max-h-[200px] overflow-y-hidden p-5 opacity-100 duration-300 ease-in-out"
            : "text-body-5 max-h-0 overflow-hidden px-5 py-0 opacity-0 duration-300 ease-in-out",
          "transition-max-h",
        )}>
        {answer}
      </p>
    </div>
  )
}
